import React from 'react';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';

import { MailchimpSignupForm } from '../../forms';
import css from './MailchimpSignupPage.module.css';

const MailchimpSignupPage = () => {
  // prettier-ignore
  return (
    <StaticPage
      title="Signup for Signalise updates"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'MailchimpSignupPage',
        description: 'Signup for updates about Signalise',
        name: 'Signup to Signalise updates page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer/>
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>Stay up to date with Signalise</h1>

          <div className={css.contentWrapper}>
            <div className={css.contentSide}>
              <p>Subscribe to our newsletter to receive email updates on what Signalise is doing.</p>
            </div>

            <div className={css.contentMain}>
              <MailchimpSignupForm />
          </div>
      </div>
    </LayoutWrapperMain>

  <LayoutWrapperFooter>
    <Footer/>
  </LayoutWrapperFooter>
</LayoutSingleColumn>
</StaticPage>
);
};

export default MailchimpSignupPage;
